import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="Scenery | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <div className="ch-lang-en">
            <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>Chinese</Link>
          </div>
          <div className="space-50"></div>
          <h2>Attractions in Ho Chi Minh City</h2>
          <p align="justify">
            <b>
            Ho Chi Minh City, formerly known as Saigon, is the largest city in Vietnam by population. Located in the southern part of the country, it serves as a vital economic, cultural, and educational hub. The city is renowned for its vibrant street life, bustling markets, and a unique blend of architectural styles that reflect its historical layers, ranging from French colonial buildings to modern skyscrapers.
            <br></br>
            Ho Chi Minh City is also famous for its historical sites, including the War Remnants Museum, which offers insights into the Vietnam War through exhibits and displays. Another notable site is the Reunification Palace, a symbol of the country&apos;s reunification in 1975.
            <br></br>
            The city&apos;s culinary scene is a paradise for food lovers, featuring a wide array of delicious Vietnamese dishes such as pho, banh mi, and fresh spring rolls. Whether you&apos;re exploring the narrow alleys of Chinatown or the trendy cafes and shops of District 1, Ho Chi Minh City offers a dynamic and captivating experience for all visitors.
            </b>
            <br />
          </p>

          <li>
            <a href="#War Remnants Museum">War Remnants Museum</a>
          </li>
          <li>
            <a href="#Saigon Opera House">Saigon Opera House.</a>
          </li>
          <li>
            <a href="#Ho Chi Minh Square">Ho Chi Minh Square</a>
          </li>
          <li>
            <a href="#Notre Dame Cathedral:">Notre Dame Cathedral </a>
          </li>
          <li>
            <a href="#Central Post Office">Central Post Office</a>
          </li>
          <li>
            <a href="#Reunification Palace">Reunification Palace</a>
          </li>
          <li>
            <a href="#Bitexco Financial Tower">Bitexco Financial Tower</a>
          </li>

          <br />

          <hr></hr>
          <h4 id="War Remnants Museum">War Remnants Museum</h4>
          <p align="justify">
          The War Remnants Museum offers a poignant and sobering look at the impact of the Vietnam War, known locally as the American War. Through a collection of photographs, military equipment, and personal anecdotes, the museum provides a narrative of the war&apos;s legacy and its lasting effects on the Vietnamese people. It&apos;s a must-visit for those seeking to understand Vietnam&apos;s recent history and the resilience of its citizens.     </p>
          <p>
            <img
              src="./images/xigong/war-remnants-museum.jpg"
              alt="War Remnants Museum"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Saigon Opera House">Saigon Opera House</h4>
          <p align="justify">
          The Saigon Opera House, also known as the Municipal Theatre, is a splendid example of French colonial architecture in the heart of Ho Chi Minh City. Built in the late 19th century, this elegant building hosts a variety of cultural performances, including opera, ballet, and traditional Vietnamese music and dance. Its beautifully restored interior and façade make it a cultural icon and a focal point for the performing arts in Vietnam.          </p>
          <p>
            <img
              src="./images/xigong/opera-house.jpg"
              alt="Saigon Opera House"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Ho Chi Minh Square">Ho Chi Minh Square</h4>
          <p align="justify">
          Ho Chi Minh Square is a spacious public area located in the city center, a popular gathering place for locals and tourists alike. It is surrounded by historic buildings and manicured gardens, providing a scenic backdrop for the statue of Ho Chi Minh, the revered leader after whom the city is named. The square is often the site of festivals and events, and is a great starting point for exploring the city&apos;s attractions.    </p>
          <p>
            <img
              src="./images/xigong/ho-chi-minh-square.jpg"
              alt="Ho Chi Minh Square"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Notre Dame Cathedral">Notre Dame Cathedral</h4>
          <p align="justify">
          The Notre Dame Cathedral, officially known as the Cathedral Basilica of Our Lady of The Immaculate Conception, is a magnificent architectural masterpiece from the French colonial era. Constructed with materials entirely imported from France, the cathedral&apos;s twin bell towers dominate the city&apos;s skyline. Although services are conducted in Vietnamese, the cathedral remains a symbol of the Catholic faith in Vietnam and a testament to the country&apos;s colonial past.          </p>
          <p>
            <img
              src="./images/xigong/beautiful-cathedral.jpg"
              alt="Notre Dame Cathedral"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Central Post Office">Central Post Office</h4>
          <p align="justify">
          Yangmei Ancient town was founded in the Song Dynasty and prospered in the late Ming and early Qing dynasties. It has a history of thousands of years. It is famous for its ancient town, old street, clear water, golden beach, strange stones and strange trees. It is also the base of revolutionary activities of Huang Xing and Liang Liya of the Revolutionary Party of 1911. Yangmei Ancient Town has more than 300 buildings of Ming and Qing dynasties, won the &quot;Chinese historical and cultural village&quot;, is a well-preserved precious historical and cultural heritage in Nanning. Yangmei is the most complete place where the ancient buildings of Ming and Qing dynasties are preserved in Nanning city. There are more than 200 preserved cultural heritages all over the town, most of which are distributed in the streets of the ancient town. Some distinctive folk houses of Ming and Qing Dynasties are still intact, so it is also named &quot;Yangmei Ancient Town&quot; today. Famous for its ancient town, old street, clear water, golden beach, strange stones and strange trees, it is also the base of revolutionary activities carried out by Huang Xing and Liang Liya of the Revolutionary Party of 1911. There are more than 700 buildings of Ming and Qing dynasties. The more complete scenic spots are: Qing Dynasty street, Ming Dynasty residences, Kuixing Tower, Huang Manor, ancient port pier, etc. Yangmei River Beach and the surrounding Zuojiang River are also picturesque, with its green slope recalling the past, sword into the spring, pine beach, Lei Feng green, pavilion over the river, golden sand moonlight, Dragon Tan night shadow, Pavilion looking at the clouds and other eight views especially famous.
          </p>
          <p>
            <img
              src="./images/xigong/post-office-interior.jpg"
              alt="Central Post Office"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Reunification Palace">Reunification Palace</h4>
          <p align="justify">
          The Reunification Palace, once known as the Independence Palace, is a symbolic site where the Vietnam War ended when a North Vietnamese Army tank crashed through its gates in 1975. The palace has since been preserved almost exactly as it was during that historic moment, including the war command room with old maps and communication equipment. Tours of the palace offer a glimpse into the life of the South Vietnamese government during the war years.          </p>
          <p>
            <img
              src="./images/xigong/the-independence-palace.jpg"
              alt="Reunification Palace"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Jiulong Waterfall">Bitexco Financial Tower</h4>
          <p align="justify">
          The Bitexco Financial Tower stands as a testament to Vietnam&apos;s rapid economic growth, soaring over Ho Chi Minh City&apos;s skyline as the tallest building at its completion. This 68-story skyscraper features a distinctive helipad extending from the 49th floor, resembling a blossoming lotus bud. Visitors can ascend to the Saigon Skydeck on the 49th floor for panoramic views of the city, or enjoy fine dining and shopping within the tower&apos;s modern facilities.         
          </p>
          <p>
            <img
              src="./images/xigong/bitexco-financial-tower.jpg"
              alt="Bitexco Financial Tower"
              width="100%"
            />
          </p>


          
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
